import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_pro_line",
  "use": "icon-home_pro_line-usage",
  "viewBox": "0 0 4 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4 26\" id=\"icon-home_pro_line\"><defs><style>#icon-home_pro_line .a{fill:#fc6e09;}</style></defs><rect class=\"a\" width=\"4\" height=\"26\" rx=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol